import EmptyState from '@Guidelines/Component/EmptyState';
import { theme } from '@Guidelines/Theme/theme';
import { TriangleAlert } from 'lucide-react';
import type * as React from 'react';
import { Skeleton } from '@verclam/ui-kit';

type Props = {
	readonly hasNoOrganization: boolean;
};

/** What the screens show while there is no current organization: a skeleton, or the reason there is none. */
const OrganizationPending: React.FC<Props> = ({ hasNoOrganization }) => {
	if (hasNoOrganization) {
		return (
			<EmptyState
				title="Aucune structure"
				description="Vous n’êtes affecté à aucune structure : aucun groupe de documents ne peut être chargé."
				icon={<TriangleAlert size={28} />}
			/>
		);
	}

	return <Skeleton height="10rem" borderRadius={theme.radii.xlarge} animation="wave" />;
};

export default OrganizationPending;
